import overview from './overview.json';
import sunburst from './sunburst.json';
import sunburstMock from './sunburstMock.json';
import cacheVsMemoryUsage from './cacheVsMemoryUsage.json';
import sqlCpuVsTotalConnections from './sqlCpuVsTotalConnections.json';
import csgClusterMemoryUsage from './csgClusterMemoryUsage.json';
import lbActiveConnectionsVsRequestTime from './lbActiveConnectionsVsRequestTime.json';
import ecsCpuUtilization from './ecsCpuUtilization.json';
import ecsMemoryUtilization from './ecsMemoryUtilization.json';

export default [
  overview,
  sunburst,
  sunburstMock,
  cacheVsMemoryUsage,
  sqlCpuVsTotalConnections,
  csgClusterMemoryUsage,
  lbActiveConnectionsVsRequestTime,
  ecsCpuUtilization,
  ecsMemoryUtilization,
];
